var map = {
	"./bender.webp": 3902,
	"./circle_square.webp": 2212,
	"./circles.webp": 7079,
	"./getintouch.webp": 6216,
	"./identitaDigitale.webp": 931,
	"./mobile/bender.webp": 6329,
	"./mobile/circle_square.webp": 9317,
	"./mobile/circles.webp": 6802,
	"./mobile/getintouch.webp": 7563,
	"./mobile/identitaDigitale.webp": 836,
	"./mobile/motoreInteresse.webp": 9529,
	"./mobile/notarizeMe.webp": 8067,
	"./mobile/opener.webp": 4694,
	"./mobile/phone-fifth.webp": 9715,
	"./mobile/phone-first.webp": 3620,
	"./mobile/phone-fouth.webp": 8612,
	"./mobile/phone-second.webp": 5078,
	"./mobile/phone-third.webp": 8319,
	"./mobile/squares.webp": 1407,
	"./motoreInteresse.webp": 5452,
	"./notarizeMe.webp": 3020,
	"./opener.webp": 901,
	"./phone-fifth.webp": 8494,
	"./phone-first.webp": 361,
	"./phone-fouth.webp": 313,
	"./phone-second.webp": 9341,
	"./phone-third.webp": 6350,
	"./squares.webp": 5982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;